import { useState } from "react";

export default function Button({
  variant = "solid", // "solid" | "outline"
  children,
  onClick,
  disabled = false,
  style = {},
}) {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);

  const isOutline = variant === "outline";

  const computedStyle = {
    ...baseStyles,
    ...(isOutline ? outlineStyles : solidStyles),
    ...(hovered && !disabled ? hoverStyles[variant] : {}),
    ...(active && !disabled ? activeStyles[variant] : {}),
    ...(disabled ? disabledStyles : {}),
    ...style,
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={computedStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setActive(false);
      }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
    >
      {children}
    </button>
  );
}

const baseStyles = {
  padding: "12px 24px",
  fontSize: 16,
  fontStyle: "italic",
  fontWeight: 700,
  borderRadius: 2,
  cursor: "pointer",
  border: "none",
  outline: "none",
  userSelect: "none",
  transition: "all 0.15s ease"
};

const solidStyles = {
  backgroundColor: "#3B00FF",
  color: "#FFFFFF",
};

const outlineStyles = {
  backgroundColor: "#FFFFFF",
  color: "#3B00FF",
  border: "2px solid #3B00FF",
};

/* Hover */
const hoverStyles = {
  solid: {
    backgroundColor: "#2f00cc",
    transform: "translateY(-1px)",
  },
  outline: {
    backgroundColor: "#f3f0ff",
  },
};

/* Active (click) */
const activeStyles = {
  solid: {
    backgroundColor: "#2500a8",
    transform: "translateY(0)",
  },
  outline: {
    backgroundColor: "#e6e0ff",
  },
};

const disabledStyles = {
  opacity: 0.6,
  cursor: "not-allowed",
  transform: "none",
};

